import { render, staticRenderFns } from "./Internal-Parts.vue?vue&type=template&id=2fa460fb"
import script from "./Internal-Parts.vue?vue&type=script&lang=js"
export * from "./Internal-Parts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports